<template>
    <div class="p-3 col-xl-6 mx-auto">
        <label for="">Выберите объект:</label>
        <v-select v-model="selected" :options="objects" label="objectName" append-to-body :clearable="false"/>
        <div class="mt-3 text-danger text-center" v-if="selected && !fuel.length && !onProcess">
            Невозможно подать отчет по данному объекту по причине отсутствия лимитов по топливу. Куратор вашего объекта
            не установил общий лимит топлива на объект. Попросите его это сделать и уже после возвращайтесь.
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: "StepOne",
    computed: {
        objects() {
            return this.$store.state.shiftReport.availableObjects.map(el => {
                el.objectName = el.bo ? el.bo.name : `Удаленный объект! (процесс ${el.building_process_id})`;
                return el;
            });
        },
        selected: {
            get() {
                const {$store: {state}, objects} = this;
                return objects.find(el => el.building_process_id === state.shiftReport.selectedProcess);
            },
            set(v) {
                this.manualObjectChange = true;
                this.$store.commit(`shiftReport_setSelectedProcess`, v.building_process_id);
                this.onChange();
            }
        },
        fuel() {
            return this.$store.state.shiftReport.fuel;
        },
        onProcess() {
            return this.$store.state.shiftReport.onProcess;
        },
        isResumeRequested() {
            return String(this.$route.query.resume || '').toLowerCase() === 'true';
        }
    },
    data() {
        return {
            manualObjectChange: false
        };
    },
    mounted() {
        const {selected, fuel} = this;
        this.$emit(`can-continue`, {
            value: Boolean(selected) && fuel.length
        });
    },
    methods: {
        getFuelLimits(preserveExistingValues = false) {
            const {$store: {dispatch, commit, state}} = this;
            return dispatch(`shiftReport_getFuelLimits`)
                .then(limits => {
                    const currentById = preserveExistingValues
                        ? new Map((state.shiftReport.fuel || []).map(item => [String(item.id), item]))
                        : new Map();
                    commit(`shiftReport_setFuel`, limits.map(el => {
                        const current = currentById.get(String(el.id));
                        return {
                            id: el.id,
                            name: el.name,
                            unit: el.unit,
                            value: current
                                ? current.value
                                : null,
                            note: current
                                ? (current.note || ``)
                                : (el.lastNote || ``),
                            limit: el.value
                        }
                    }));
                    return limits;
                });                
        },
        onChange() {
            this.$store.dispatch(`shiftReport_clearForm`);
            this.$store.dispatch(`shiftReport_setDefaultTime`);
            const now = moment();          
            this.$store.commit(`shiftReport_setStartDate`, now.format('YYYY-MM-DD'));
        }
    },
    watch: {
        selected(val) {
            if (val) {
                this.$store.commit(`shiftReport_setOnProcess`, true);
                const preserveExistingValues = this.isResumeRequested && !this.manualObjectChange;
                this.getFuelLimits(preserveExistingValues).then(limits => {
                    this.$emit(`can-continue`, {
                        value: limits.length
                    });
                }).finally(() => {
                    this.manualObjectChange = false;
                    this.$store.commit(`shiftReport_setOnProcess`, false);
                });
            } else {
                this.$emit(`can-continue`, {
                    value: false
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
